module.exports = __webpack_public_path__ + "05a903a60fd3f3381f34a93c5be11cef.pdf";